/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Form, Input, message, Modal } from "antd";
import React, { useCallback } from "react";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { AccountSeviceClient } from "src/services/CompanyService";

export default React.memo(
  (props: { isRenew: boolean; onRenew: () => void; companyId: string }) => {
    const { isRenew, onRenew, companyId } = props;
    const formatMessage = useFormatMessage();
    const [form] = Form.useForm();

    const onCancel = useCallback(() => {
      form.resetFields();
      onRenew();
    }, [form, onRenew]);

    const onComfirm = useCallback(async () => {
      const renewLicense = await form.validateFields();
      AccountSeviceClient.activateLicense(companyId, renewLicense.license).then(
        () => {
          message.success(
            formatMessage(messageIds.company.renewContractSuccessfully)
          );
        }
      );
      onCancel();
    }, [companyId, form, formatMessage, onCancel]);

    return (
      <Modal
        title={formatMessage(messageIds.company.renewContract)}
        visible={isRenew}
        footer={""}
        onCancel={onCancel}
        css={css`
          .ant-modal-header {
            border-bottom: none;
          }
        `}
      >
        <Form layout="vertical" form={form}>
          <Form.Item
            label={formatMessage(messageIds.license.common.name)}
            name="license"
            rules={[
              {
                required: true,
              },
              {
                whitespace: true,
              },
            ]}
          >
            <Input.TextArea rows={10}></Input.TextArea>
          </Form.Item>
        </Form>
        <div
          css={css`
            text-align: right;
          `}
        >
          <Button
            css={css`
              margin-right: 20px;
            `}
            onClick={onCancel}
          >
            {formatMessage(messageIds.common.cancel)}
          </Button>
          <Button type="primary" onClick={onComfirm}>
            {formatMessage(messageIds.common.confirm)}
          </Button>
        </div>
      </Modal>
    );
  }
);
